<template>
  <div class="wxsmallcode-page publicCon">
    <div class="copyBox">
      sysAppId：<span>{{sysAppIds}}</span>
      <el-button class="ml10" type="text" size="medium"
        v-clipboard:copy="sysAppIds"
        @click="addMsg">点击复制</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      sysAppIds: 'xxxxxxxxxxxsx'
    }
  },
  methods: {
    // 复制成功
    onCopy(e){
      alert(sysAppIds);
    },
    // 复制失败
    onError(e){
      alert("失败");
    },
    addMsg(){
    
      this.sysAppIds = 12123131;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/copy/copy.vue